<template>
  <div>
    <MatchReadPopup :isModal="modalPopup.matchNapPopup" />
    <AnswerNapPopup :isModal="modalPopup.answerNapPopup" />
  </div>
</template>
<script>
import MatchReadPopup from "@/components/matching/popup/nap/MatchNapPopup.vue";
import AnswerNapPopup from "@/components/matching/popup/nap/AnswerNapPopup.vue";
import { mapState } from "vuex";
export default {
  name: "MatchingSentPopups",
  components: { MatchReadPopup, AnswerNapPopup },
  computed: {
    ...mapState("directMatching", ["modalPopup"]),
  },
};
</script>
